import React, {memo} from 'react';
import PropTypes from 'prop-types';
import ViewMoreLink from 'cms/blog/ViewMoreLink';

const CategoryWrapper = ({title, link, viewMoreText, children}) => (
  <div className="p-3">
    <div className="mb-3 d-flex justify-content-between align-items-center">
      <h4><a href={link}>{title}</a></h4>
      <ViewMoreLink link={link} text={viewMoreText} />
    </div>
    {children}
  </div>
);

CategoryWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  viewMoreText: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired
};

export default memo(CategoryWrapper);
